<template>
  <div :class="$style.ZyTable" class="zyTable">
    <div class="Table__TopPage--middle" v-if="pagerData" v-show="paginationBackground">
        共{{ pagerData.allCount }}条 | 每页{{ pagerData.pageSize }}条 | 共{{ pagerData.pageCount }}页
        <slot name="top"></slot>
    </div>
    <el-table
      :data="data"
      :height="height"
      :row-class-name="rowClassName"
      :span-method="spanMethod"
      v-bind="tableAttr"
      border
    >
      <slot name="left"></slot>
      <el-table-column
        label="序号"
        align="center"
        v-if="showIndex"
        type="index"
        :index="indexMethod"
        width="80">
      </el-table-column>
      <el-table-column
        v-for="item in showKeys"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :align="item.align || 'center'"
        :min-width="item.minWidth"
        :width="item.width"
        :fixed="item.fixed"
      >
        <template slot-scope="{ row }">
          <div v-if="item.components" :style="item.style">
            <component v-for="(com, comIndex) in item.components" :key="comIndex"
              :is="com.is"
              v-model="row[com.prop]"
              v-bind="{
                row,
                ...com.propOptions
              }"
              @click="com.click && com.click(row)"
              @change="com.change && com.change(row)"
            >
              {{ row | formatValue(com) }}
            </component>
          </div>
          <div v-else-if="item.type === 'html'"
            v-html="$options.filters.formatValue(row, item)"
            @click="item.click && item.click(row)"
            v-bind="{
              ...item.propOptions
            }"
          ></div>
          <div v-else-if="item.type === 'slot'">
            <slot :name="item.prop" :row="row" :item="item"></slot>
          </div>
          <div v-else-if="item.type === 'tooltip'">
            <span v-if="checkoutLen(row[item.prop], item)">{{ row | formatValue(item) }}</span>
            <el-tooltip v-else class="item" effect="dark" :content="row | formatValue(item)" placement="top">
              <span>{{ row | formatValue(item) | formatTooltipValue(item) }}</span>
            </el-tooltip>
          </div>
          <span v-else>{{ row | formatValue(item) }}</span>
        </template>

      </el-table-column>
      <slot name="right"></slot>
    </el-table>
    <div :class="['u-nbfc']" v-if="pagerData">
      <el-pagination
        class="u-fr"
        :background="paginationBackground"
        :current-page="pagerData.page"
        :pageSize="pagerData.pageSize"
        :total="pagerData.allCount"
        :layout="pageLayout"
        @current-change="$emit('page-change', $event)"
      />
    </div>
  </div>
</template>

<script>
import { hasPermission } from '@/permission/index'
export default {
  name: 'ZyTable',
  props: {
    /**
     * pagerData: {
        allCount: 0, // 总条数
        pageCount: 0, // 总页数
        pageSize: 0, // 每页条数
        page: 0, // 当前页码
      }
     */
    pagerData: Object,
    data: { // 表格数据
      type: Array,
      default: () => [],
    },
    keys: { // 表格头{ key: keyName, }
      type: Object,
      default: () => {},
    },
    colOptions: { // 列选项，处理特殊key { key: { ...options}, }
      type: Object,
      default: () => {},
    },
    showIndex: {
      type: Boolean,
      default: false,
    },
    paginationBackground: {
      type: Boolean,
      default: true,
    },
    pageLayout: {
      type: String,
      default: 'prev, pager, next'
    },
    tableAttr: Object,
    height: String,
    rowClassName: Function,
    spanMethod: Function,
  },
  filters: {
    formatValue(row, item) {
      return item.format ? item.format(row[item.prop], row) : (row[item.prop]?.toString() ?  row[item.prop] : item.text)
    },
    formatTooltipValue (value, item) {
      let len = value?.length
      let itemLen = item.len || 10
      const showValue = value?.slice(0, itemLen)
      return len > itemLen ? showValue + '...' : showValue
    },
    
  },
  computed: {
    showKeys () {
      let keysArr = Object.keys({...this.keys, ...this.colOptions}).map(key => 
        Object.assign({
          label: this.keys[key],
          prop: key,
        }, this.colOptions?.[key] || {})
      )
      return keysArr.filter(item => !item.per || hasPermission(item.per))
    }
  },
  methods: {
    checkoutLen (value, item) {
      let itemLen = item.len || 10
      return value?.length < itemLen
    },
    indexMethod(index) {
      return index + 1 + (this.pagerData ? (this.pagerData.pageSize * (this.pagerData.page - 1)) : 0);
    }
  }
}
</script>

<style lang='scss' module>
.ZyTable {
  font-size: 12px;
  background-color: #fff;
}
</style>